import { Checkbox, Divider, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { BodyInterestedPeopleVM } from 'practice/view-models/practice-detail';
import { noop } from 'shell/utils/noop';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';

interface FormProps {
  disabled?: boolean;
  values?: BodyInterestedPeopleVM;
}

const FormComponent = ({ disabled, values }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Codice fiscale"
          label="Codice fiscale"
          id="fiscalCode"
          name="fiscalCode"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.fiscalCode?.toUpperCase() || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="isAire"
              checked={values?.aire === 'S'}
              onChange={noop}
              inputProps={{ 'aria-label': 'Aire' }}
              disabled={disabled}
            />
          }
          label="AIRE"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="isAire"
              checked={values?.accountholder || false}
              onChange={noop}
              inputProps={{ 'aria-label': 'Intestatario' }}
              disabled={disabled}
            />
          }
          label="Intestatario"
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Parentela"
          label="Parentela"
          id="fiscalCode"
          name="fiscalCode"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.relationship || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          value={values?.surname || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurname-replica"
              checked={!Boolean(values?.surname)}
              onChange={noop}
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
              disabled={disabled}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          value={values?.name || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutName-replica"
              checked={!Boolean(values?.name)}
              onChange={noop}
              inputProps={{ 'aria-label': 'Persona senza nome' }}
              disabled={disabled}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Sesso"
          label="Sesso"
          id="gender"
          name="gender"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.gender || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Patente"
          label="Patente"
          id="licenseValue"
          name="licenseValue"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.licenseValue || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Veicoli"
          label="Veicoli"
          id="carValue"
          name="carValue"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.carValue || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Nascita</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={12}>
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Data di nascita"
            label="Data di nascita"
            id="dateBirth"
            name="dateBirth"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.dateBirth || ''}
            onChange={noop}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Comune"
          label="Comune"
          id="placeBirth"
          name="placeBirth"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.placeBirth || ''}
          onChange={noop}
          disabled={disabled}
        />
      </Grid>
      {Boolean(values?.provinceBirth) ? (
        <Grid item xs={12} md={3}>
          <PmiTextField
            aria-label="Provincia"
            label="Provincia"
            id="provinceBirth"
            name="provinceBirth"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.provinceBirth || ''}
            onChange={noop}
            disabled={disabled}
          />
        </Grid>
      ) : (
        <Grid item xs={12} md={5}>
          <PmiTextField
            aria-label="Nazione"
            label="Nazione"
            id="stateBirth"
            name="stateBirth"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.stateBirth || ''}
            onChange={noop}
            disabled={disabled}
          />
        </Grid>
      )}
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion address - form';

const Form = memo(FormComponent);

export default Form;
